<template>
  <div>
    <PageTitleVue
      :sub-title="subTitle"
      :key="pageTitle"
      :small="
        pageTitle == 'ESTATISTICAS' ||
        pageTitle == 'COMITÊS' ||
        pageTitle == 'REGISTRAR RCD' ||
        pageTitle == 'NOVA EMPRESA' ||
        pageTitle == 'NOVO COMITÊ' ||
        pageTitle == 'ATUALIZAR EMPRESA' ||
        pageTitle == 'ATUALIZAR COMITÊ'
          ? true
          : false
      "
    >
      {{ pageTitle }}

      <template #b-action>
        <div class="my-1 -mt-1">
          <Transition mode="out-in">
            <!-- relatos -->
            <Create
              v-if="store.getters.getActiveComponent.__name === 'RelatosList'"
              :icon="PhFilePlus"
              :label="'Novo relato'"
              :width-medium="true"
              @click="setFormComponentActive()"
            />
            <Create
              v-else-if="
                store.getters.getActiveComponent.__name === 'NewRcdForm'
              "
              :icon="PhArrowLeft"
              :label="'Ver relatos'"
              :width-medium="true"
              @click="setListComponentActive()"
            />

            <!-- unidades -->
            <Create
              v-else-if="
                store.getters.getActiveComponent.__name === 'UnidadesList'
              "
              :icon="PhBuildingApartment"
              :label="'Nova empresa'"
              :width-medium="true"
              @click="setComponentActiveFormUnidade()"
            />
            <Create
              v-else-if="
                store.getters.getActiveComponent.__name === 'NewUnidadeForm' ||
                store.getters.getActiveComponent.__name === 'UpdateUnidadeForm'
              "
              :icon="PhArrowLeft"
              :label="'Ver empresas'"
              :width-medium="true"
              @click="setListUnidadeComponentActive()"
            />

            <!-- setores -->
            <Create
              v-else-if="
                store.getters.getActiveComponent.__name === 'SetoresList'
              "
              :icon="PhGitBranch"
              :label="'Novo comitê'"
              :width-medium="true"
              @click="setComponentActiveFormSector()"
            />
            <Create
              v-else-if="
                store.getters.getActiveComponent.__name === 'NewSectorForm' ||
                store.getters.getActiveComponent.__name === 'UpdateSectorForm'
              "
              :icon="PhArrowLeft"
              :label="'Ver comitês'"
              :width-medium="true"
              @click="setComponentActiveListSectors()"
            />
          </Transition>
        </div>
      </template>
    </PageTitleVue>

    <RcdTabs>
      <template #relatos>
        <ListAndFormNewRcd />
      </template>

      <template #cadastros>
        <div
          class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white"
        >
          <DropDownOptions
            v-model="selectedFilter"
            :label="'OPÇÕES DE CADASTRO'"
            :options="['EMPRESAS', 'COMITÊS']"
          />
        </div>

        <ListAndForms />
      </template>

      <template #statistics>
        <Statistics />
      </template>
    </RcdTabs>
  </div>
</template>

<script setup>
import DropDownOptions from "@/components/Tables/DropDownOptions.vue";
import ListAndForms from "./layout/ListAndFormUnidadeAndSectors.vue";
import ListAndFormNewRcd from "./layout/ListAndFormNewRcd.vue";
import PageTitleVue from "@/components/Titles/PageTitle.vue";
import RcdTabs from "./components/_partials/RcdTabs.vue";
import Statistics from "./layout/pages/Statistics.vue";
import Create from "@/components/Buttons/Create.vue";
import RcdService from "./service/rcd.service";
import {
  PhArrowLeft,
  PhBuildingApartment,
  PhFilePlus,
  PhGitBranch,
} from "@phosphor-icons/vue";
import { onBeforeMount, watch, computed, ref } from "vue";
import { initFlowbite } from "flowbite";
import { storeApp } from "@/store";
import { dataRcd } from "./store";

import { showToast as toast } from "@/helpers/UseToasts";

const store = dataRcd;
const subTitle = ref("");
const selectedFilter = ref("");

const pageTitle = computed(() => {
  if (store.getters.getActiveComponent.__name == "RelatosList") {
    subTitle.value = "Gerencie todos os relatos cadastrados";
    return "RELATOS";
  }
  if (store.getters.getActiveComponent.__name == "NewRcdForm") {
    subTitle.value = "Faça o cadastro de um novo desvio comportamental";
    return "REGISTRAR RCD";
  }

  if (store.getters.getActiveComponent.__name == "UnidadesList") {
    subTitle.value = "Gerencie suas empresas";
    return "EMPRESAS";
  }
  if (store.getters.getActiveComponent.__name == "NewUnidadeForm") {
    subTitle.value = "Adicione uma nova empresa para gerenciar";
    return "NOVA EMPRESA";
  }
  if (store.getters.getActiveComponent.__name == "UpdateUnidadeForm") {
    subTitle.value = "Altere os dados desta unidade de maneira facil";
    return "ATUALIZAR EMPRESA";
  }

  if (store.getters.getActiveComponent.__name == "SetoresList") {
    subTitle.value = "Gerencie seus comites";
    return "COMITÊS";
  }
  if (store.getters.getActiveComponent.__name == "NewSectorForm") {
    subTitle.value = "Faça o cadastro de um novo comitê";
    return "NOVO COMITÊ";
  }
  if (store.getters.getActiveComponent.__name == "UpdateSectorForm") {
    subTitle.value = "Altere os dados deste comite de maneira facil";
    return "ATUALIZAR COMITÊ";
  }

  if (store.getters.getActiveTab == "statistics") {
    subTitle.value = "Tenha uma visão geral e moderna dos seus relatos";
    return "ESTATISTICAS";
  }
});

// option selected
watch(
  () => selectedFilter.value,
  (newVal) => {
    selectedFilter.value = "";

    if (newVal == "EMPRESAS") {
      dataRcd.dispatch("setComponentActiveUnidade");
    }

    if (newVal == "COMITÊS") {
      dataRcd.dispatch("setComponentActiveSectors");
    }
  },
  { immediate: true }
);

// tabs
watch(
  () => store.getters.getActiveTab,
  (newVal) => {
    if (newVal === "relatos") {
      return setListComponentActive();
    }

    if (newVal === "cadastros") {
      return setListUnidadeComponentActive();
    }

    if (newVal === "statistics") {
      return setComponentActiveStatistics();
    }
  },
  { immediate: true }
);

// reset forms
watch(
  () => store.getters.getActiveComponent.__name,
  (newVal) => {
    if (
      newVal === "NewUnidadeForm" ||
      newVal === "NewSectorForm" ||
      newVal === "NewRcdForm"
    ) {
      store.dispatch("resetForms");
    }
    store.dispatch("resetRelatoForm");
  },
  { immediate: true }
);

// define a listagem de relatos
function setListComponentActive() {
  dataRcd.dispatch("setListComponentActive");
}
// define o form de cadastro de relatos
function setFormComponentActive() {
  dataRcd.dispatch("setFormComponentActive");
}

// define o form de unidades
function setComponentActiveFormUnidade() {
  dataRcd.dispatch("setComponentActiveFormUnidade");
}
function setListUnidadeComponentActive() {
  dataRcd.dispatch("setComponentActiveUnidade");
}

// define o form de setores
function setComponentActiveFormSector() {
  dataRcd.dispatch("setComponentActiveFormSector");
}
function setComponentActiveListSectors() {
  dataRcd.dispatch("setComponentActiveSectors");
}

// ativa a tela de estatisticas
function setComponentActiveStatistics() {
  dataRcd.dispatch("setComponentActiveStatistics");
}

// pega todos os relatos
async function getAllRelatos() {
  await RcdService.allRelatos()
    .then((res) => {
      store.dispatch("setRelatos", res?.data?.relatos);
    })
    .catch((err) => {
      return toast("Aviso", "Algo deu errado ao buscar relatos", "error");
    });
}

// pega as unidades
async function getUnidades() {
  await RcdService.getAllUnidades()
    .then((res) => {
      store.dispatch("setUnidades", res.data.unidades);
    })
    .catch((err) => {
      return toast("Aviso", "Algo deu errado ao buscar empresas", "error");
    });
}

// pega todos os setores
async function getSetores() {
  await RcdService.getAllSectors()
    .then((res) => {
      store.dispatch("setSectors", res.data.setores);
    })
    .catch((err) => {
      return toast("Aviso", "Algo deu errado ao buscar comitês", "error");
    });
}

// pega as estatisticas
async function getStatistics() {
  await RcdService.statistics()
    .then((res) => {
      dataRcd.dispatch("setStatistics", res.data);
    })
    .catch((err) => {
      return toast("Aviso", "Algo deu errado ao buscar estatisticas", "error");
    });

  await RcdService.getDataCards()
    .then((res) => {
      dataRcd.dispatch("setCards", res.data);
    })
    .catch((err) => {
      return toast("Aviso", "Algo deu errado ao buscar estatisticas", "error");
    });
}

onBeforeMount(async () => {
  storeApp.state.loading = true;
  dataRcd.dispatch("setActiveTab", "relatos");
  initFlowbite();
  await getAllRelatos();
  storeApp.state.loading = false;
  Promise.allSettled([
    await getStatistics(),
    await getUnidades(),
    await getSetores(),
  ]);
});
</script>

<style scoped lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
